import { render, staticRenderFns } from "./vc_modal.vue?vue&type=template&id=22564577&"
import script from "./vc_modal.vue?vue&type=script&lang=js&"
export * from "./vc_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports